var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('vue-frame',{staticClass:"form-control dsf",attrs:{"text":"Load the Profile","url":_vm.url,"frame":"myframe","default":true,"type":"button"}}),_vm._v(" "),_c('iframe',{attrs:{"id":"myframe","frameborder":"0"}})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-3aa4af7b","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Layout/PreviewProfile.vue
// module id = f3qJ
// module chunks = 1